import "slick-carousel";
jQuery(document).ready(() => {
    jQuery('.wm-imageCarousel__carousel').each(function () {
        jQuery(this).slick({
            slidesToShow: 1,
            dots: false,
            arrows: false,
            infinite: true,
            adaptiveHeight: true,
            asNavFor: jQuery(this).siblings().find('.wm-imageCarousel__navigationCarousel')
        });
        jQuery(this).siblings().find('.wm-imageCarousel__navigationCarousel').slick({
            slidesToShow: 3,
            dots: true,
            infinite: true,
            focusOnSelect: true,
            prevArrow: jQuery(this).siblings().find('.wm-imageCarousel__navigationArrow.-prev'),
            nextArrow: jQuery(this).siblings().find('.wm-imageCarousel__navigationArrow.-next'),
            asNavFor: jQuery(this),
        });
    });
    if (jQuery(window).width() < 576) {
        jQuery('.wm-mobileCarousel').each(function () {
            jQuery(this).slick({
                slidesToShow: 1,
                dots: true,
                arrows: true,
                infinite: true,
                adaptiveHeight: true,
            });
        });
    }
    jQuery('.wm-extraEquipmentCarousel__carousel').each(function () {
        jQuery(this).slick({
            slidesToShow: 1,
            dots: false,
            arrows: true,
            infinite: true,
            fade: true,
            adaptiveHeight: true,
            prevArrow: jQuery(this).siblings().find('.wm-extraEquipmentCarousel__navigationArrow.-prev'),
            nextArrow: jQuery(this).siblings().find('.wm-extraEquipmentCarousel__navigationArrow.-next'),
            responsive: [
                {
                    breakpoint: 577,
                    settings: {
                        dots: true,
                        appendDots: jQuery(this).siblings().find('.wm-extraEquipmentCarousel__navigationDots'),
                    }
                },
            ]
        });
    });
    jQuery('.wm-carouselWithCaptions').each(function () {
        jQuery(this).slick({
            slidesToShow: 1,
            dots: false,
            arrows: true,
            infinite: true,
            adaptiveHeight: true,
            fade: true,
        });
    });
});
